import React from 'react';
import { TypedMemo } from '../common/types';
import { useCurrentNavScreen } from '../music24/navigation/hooks/useCurrentNavScreen';
import { showsArtistPill } from '../music24/navigation/smlNavigation';
import { ArtistSwitcher } from './ArtistSwitcher';
import { useWorkspaceArtists } from './useWorkspaceArtists';
import styles from './PageArtistPill.module.scss';

/**
 * design: navigation-v2 1e. The artist switcher at the right of the desktop page bar. It shows on
 * every page but a Discover page, for any count of artists (owner, 2026-10-26). Home shows the
 * data of one artist, and without the pill there was no way to change that artist. With no artist
 * the compact switcher is the "Add artist" pill. The pill waits for the artist list. Below
 * 769 px the mobile top bar has its own pill, so the CSS hides this one.
 */
const PageArtistPillComponent: React.FC = () => {
  const { group } = useCurrentNavScreen();
  const { isLoaded } = useWorkspaceArtists();
  if (!isLoaded || !showsArtistPill(group)) {
    return null;
  }
  return (
    <div className={styles.slot} data-testid="page-artist-pill">
      <ArtistSwitcher variant="compact" />
    </div>
  );
};

export const PageArtistPill = TypedMemo(PageArtistPillComponent);
